// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vzm-material-item .vzm-material {\n    width: 132px;\n    height: 100px;\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.vzm-material-item .el-checkbox__input{\n    position: absolute;\n    top: 15px;\n    left: 15px;\n}\n.vzm-material-item .el-checkbox__label {\n    padding: 0;\n    margin: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
